<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="popupTitle" width="500px" @open="open" @close="close">
    <div slot="content">
      <div v-show="!dataSourceShowFlag">
        <div>
          <el-row class="title-bar">
            <div class="title-h4">기본정보</div>
          </el-row>
          <el-form :model="rsctypeFormData" label-position="top" :rules="rules" ref="rsctypeForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="자원구분 ID" prop="rsctypeId">
                  <el-input v-model="rsctypeFormData.rsctypeId" placeholder="입력해 주세요." disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="자원구분명" prop="rsctypeName">
                  <el-input v-model="rsctypeFormData.rsctypeName" placeholder="입력해 주세요." disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="수집 주기(초)" prop="rscGetinterval">
                  <el-input-number v-model="rsctypeFormData.rscGetinterval" :disabled="managetypeId === 'APM2X'" controls-position="right" :min="1" style="width:100%"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="적용" prop="applyFlag">
                  <el-switch v-model="rsctypeFormData.applyFlag" active-value="Y" inactive-value="N" style="height:28px"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="이벤트 판단주기" prop="eventRscGetintervalId">
                  <el-select v-model="rsctypeFormData.eventRscGetintervalId" style="width:100%">
                    <el-option v-for="item in eventJudgementList" :key="item.eventRscGetintervalId" :label="item.eventRscGetintervalName" :value="item.eventRscGetintervalId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="이벤트 판단횟수" prop="eventJudgeCount">
                  <el-input-number v-model="rsctypeFormData.eventJudgeCount" controls-position="right" :min="1" style="width:100%"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="수집방식" prop="rscGetmethodId">
                  <el-select v-model="rsctypeFormData.rscGetmethodId" style="width:100%">
                    <el-option v-for="item in rscGetmethodList" :key="item.rscGetmethodId" :label="item.rscGetmethodName" :value="item.rscGetmethodId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-if="rsctypeFormData.rscGetmethodId === 'SQL'" class="mr-t25">
          <el-row type="flex" justify="space-between" class="title-bar vertical-center-box">
              <div class="title-h4">데이터소스 설정</div>
              <el-button type="primary" size="mini" @click="clickDataSourceButton">데이터소스 관리</el-button>
          </el-row>
          <el-form label-position="top">
            <el-form-item prop="sourceId">
              <el-select v-model="sourceObject.sourceId" style="width:100%" @change="changeSourceId">
                <el-option v-for="item in ruleRscGetmethodSourceList" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-row class="list form-list">
            <el-form :model="sourceObject" label-width="100px" label-position="left">
              <el-form-item label="데이터소스 ID">{{sourceObject.sourceId}}</el-form-item>
              <el-form-item label="데이터소스명">{{sourceObject.sourceName}}</el-form-item>
              <el-form-item label="DB종류">{{sourceObject.sourceData.databaseType}}</el-form-item>
              <el-form-item label="DB주소">{{sourceObject.sourceData.databaseConnectionAddress}}</el-form-item>
              <el-form-item label="DB포트">{{sourceObject.sourceData.databaseConnectionPort}}</el-form-item>
              <el-form-item label="DB명">{{sourceObject.sourceData.databaseConnectionName}}</el-form-item>
              <el-form-item label="UserID">{{sourceObject.sourceData.dabataseConnectionUserId}}</el-form-item>
            </el-form>
          </el-row>
        </div>
      </div>
      <w-data-source-setting v-show="dataSourceShowFlag" @click-back-button="changeDataSourceShowFlag" ref="dataSourceSetting"></w-data-source-setting>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" class="mr-r4" @click="saveButton">저장</el-button>
      <el-button size="large" @click="cancelButton">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import WDataSourceSetting from './DataSourceSetting';

export default {
  name: 'WUpdateRuleRsctypePopup',
  components: {
    WDataSourceSetting,
  },
  props: {
    updateRow: Object,
    managetypeId: String,
    managetypeKey: String,
  },
  data() {
    return {
      popupTitle: null,
      dataSourceShowFlag: false,
      rscGetmethodList: [],
      eventJudgementList: [],
      ruleRscGetmethodSourceList: [],
      rsctypeFormData: {
        rsctypeId: null,
        rsctypeName: null,
        rscGetinterval: 1,
        rscGetmethodId: null,
        eventRscGetintervalId: null,
        eventJudgeCount: null,
        sourceId: null,
      },
      sourceObject: {
        sourceId: null,
        sourceName: null,
        sourceData: {
          databaseType: null,
          databaseConnectionAddress: null,
          databaseConnectionName: null,
          dabataseConnectionUserId: null,
          databaseConnectionPort: null,
          databaseConnectionPassword: null,
        },
      },
      rules: {
        rscGetinterval: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        eventRscGetintervalId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        eventJudgeCount: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        rscGetmethodId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    open() {
      this.popupTitle = `[${this.updateRow.rsctypeName}] 수집/판단 정보`;
      this.rsctypeFormData = this.updateRow;
      const managetypeId = this.managetypeId;
      RscSettingsAPI.getRscGetmethodList({ managetypeId }).then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.rscGetmethodList = cloneDeep(result);
        }
      });
      RscSettingsAPI.getEventJudgementList().then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.eventJudgementList = cloneDeep(result);
        }
      });
      RscSettingsAPI.getRuleRscGetmethodSourceList().then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.ruleRscGetmethodSourceList = cloneDeep(result);
          let sourceIndex = result.findIndex((object) => object.sourceId === this.rsctypeFormData.sourceId);
          sourceIndex = sourceIndex < 0 ? 0 : sourceIndex;
          this.sourceObject = cloneDeep(result)[sourceIndex];
          this.sourceObject.sourceData = JSON.parse(cloneDeep(result)[sourceIndex].sourceData);
        }
      });
    },
    close() {
      this.dataSourceShowFlag = false;
      this.$refs.rsctypeForm.resetFields();
    },
    saveButton() {
      if (!this.dataSourceShowFlag) {
        const managetypeId = this.managetypeId;
        const managetypeKey = this.managetypeKey;
        const rsctypeFormData = this.rsctypeFormData;
        rsctypeFormData.managetypeId = managetypeId;
        rsctypeFormData.managetypeKey = managetypeKey;
        rsctypeFormData.sourceId = rsctypeFormData.rscGetmethodId === 'SQL' ? this.sourceObject.sourceId : 'DEFAULT';
        this.$refs.rsctypeForm.validate().then((response) => {
          if (response) {
            RuleSettingsAPI.updateRuleRsctypeInfo(rsctypeFormData).then(() => {
              this.$emit('re-load');
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '수집/판단 정보', true));
              this.cancelButton();
            });
          }
        }).catch(() => {
        });
      } else {
        this.$refs.dataSourceSetting.saveButton();
      }
    },
    cancelButton() {
      if (!this.dataSourceShowFlag) {
        this.$refs.slidingPopup.visible = false;
      } else {
        this.$refs.dataSourceSetting.cancelButton();
      }
    },
    clickDataSourceButton() {
      this.changeDataSourceShowFlag();
    },
    changeDataSourceShowFlag() {
      this.dataSourceShowFlag = !this.dataSourceShowFlag;
      if (this.dataSourceShowFlag) {
        this.$refs.dataSourceSetting.loadData();
      } else {
        RscSettingsAPI.getRuleRscGetmethodSourceList().then((response) => {
          const result = response.data.data;
          if (!isNil(result)) {
            this.ruleRscGetmethodSourceList = cloneDeep(result);
          }
        });
      }
    },
    changeSourceId(object) {
      this.ruleRscGetmethodSourceList.forEach((row) => {
        if (isEqual(row.sourceId, object)) {
          const tempRow = cloneDeep(row);
          tempRow.sourceData = JSON.parse(tempRow.sourceData);
          this.sourceObject = tempRow;
        }
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/UpdateRuleRsctypePopup.vue